import { TrustMarkerType } from "@interfaces/trust-markers.types";

export const getTrustMarkerSlug = (label: string): string => {
  const slugMap: Record<string, string> = {
    [TrustMarkerType.BEST_SELLER]: "best-seller",
    [TrustMarkerType.NEWLY_LAUNCHED]: "newly-launched",
    [TrustMarkerType.MOST_VIEWED]: "most-viewed",
    [TrustMarkerType.MOST_SEARCHED]: "most-searched",
  };

  return slugMap[label] || label.toLowerCase().replace(/\s+/g, "-");
};

export const getTrustMarkerCollectionUrl = (label: string): string => {
  const slug = getTrustMarkerSlug(label);
  return `/collection/${slug}/`;
};

export const isCurrentPageTrustMarkerCollection = (): boolean => {
  if (typeof window === "undefined") return false;

  const trustMarkerSlugs = [
    "best-seller",
    "newly-launched",
    "most-viewed",
    "most-searched",
  ];
  const pathname = window.location.pathname;
  const match = pathname.match(/\/collection\/([^\/]+)/);

  if (!match || !match[1]) return false;

  return trustMarkerSlugs.includes(match[1].toLowerCase().trim());
};

export const ACKODRIVE_AWARDS_URL = "/collection/ackodrive-award-winning-cars/";
